import { FC, ReactNode } from "react";
import { Box } from "./LayoutQuestionPage.styled";

export type Props = {
  children: ReactNode[];
  design_type?: number;
  //   image?: string | null;
};

export const LayoutQuestionPage: FC<Props> = ({ children, design_type }) => {
  return <Box design_type={design_type}>{children}</Box>;
};
